export function getMapValues<K, V>(cache: Map<K, V>): V[] {
  const list: V[] = [];

  for (const value of cache.values()) {
    list.push(value);
  }
  return list;
}
